import "./parent-list.scss";
import m from "mithril";
import pf from "../../old/pf";
import tabs from "../../custom-tab/custom-tab";

export default () => {
	return {
		view: ({attrs: {data}}) => {
			let tabCol = data.cols[0].name;
			let parentCol = data.cols[1].name;
			let childCol = data.cols[2].name;

			let labels = pf.Unique(data.rows.map((r) => r[tabCol].text));
			return m(tabs, {
				labels,
				tab: (i) => {
					console.log("rendering tab index ", {i});
					let parents = pf.Unique(data.rows.filter((r) => r[tabCol].text == labels[i]).map((r) => r[parentCol].text));
					console.log({parents});
					return m(".parent-list-wrapper8973453", [
						parents.map((p) => {
							return m(".parent-container", [
								m(".parent-title", p),
								m(
									".junior-links",
									data.rows
										.filter((r) => r[tabCol].text == labels[i] && r[parentCol].text == p)
										.map((r) => {
											return r[childCol].links.map((l) => m("a.child-link", {href: l.url}, l.caption));
										})
								),
							]);
						}),
					]);
				},
			});
		},
	};
};
